package fr.frux.shared.domain.model

/** Ce sur quoi porte une récolte (ADR 0035) : un arbre, ou un lieu de cueillette. */
sealed interface HarvestTarget {
    data class Tree(
        val id: Long,
    ) : HarvestTarget

    data class Site(
        val id: Long,
    ) : HarvestTarget
}
